export const REDUCER_NAME = "navigation";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_NAVIGATION = `${REDUCER_NAME}/SET_NAVIGATION`;

export const getKey = (data) => `${data.type}`;
